import React, { useEffect } from 'react'
import moment from 'moment'
import cn from 'classnames'
import { map, startCase, isEqual } from 'lodash'

import SidebarModal from './SidebarModal'
import useGetSummaryReport from '../hooks/useGetSummaryReport'
import { orderSummaryKeys } from "../utils/orderUtils"

import styles from './AttendantSummary.module.scss'

const AttendantSummary = ({
  attendantName,
  className,
  closedOrdersCount,
  menuName,
  onClose,
  openOrdersCount,
  venueName,
}) => {
  const classNames = cn(styles.attendantSummary, className)
  const [getSummaryReport, { data: totals }] = useGetSummaryReport()

  useEffect(() => {
    getSummaryReport()
  }, []) 

  const addGrayTextStyle = {
    color: 'gray'
  }

  const createField = (value = '', style = {}) => ({ 
    value,
    style,
  })
  
  const sectionOneRows = [
    [
      createField(menuName, addGrayTextStyle),
      createField(venueName, addGrayTextStyle),
    ],
    [
      createField(attendantName, addGrayTextStyle),
      createField(moment().format('DD/MM/YY HH:mm A'), addGrayTextStyle)
    ],
    [
      createField(),
    ],
    [
      createField('Order Status'),
      createField('Qty')
    ]
  ]
  
  const sectionTwoRows = [
    [
      createField('Open Orders', addGrayTextStyle),
      createField(openOrdersCount),
    ],
    [
      createField('Closed Orders', addGrayTextStyle),
      createField(closedOrdersCount)
    ],
    [
      createField(),
    ],
    [
      createField('Sales Excluding Open Orders', {fontSize: '12px', whiteSpace: 'pre'}),
      createField('Amount')
    ]
  ]
  
  const sectionThreeRows = [
    [
      createField('Gross Sales', addGrayTextStyle),
      createField(totals?.gross ?? '-'),
    ],
    [
      createField('Discounts', addGrayTextStyle),
      createField(totals?.discounts ?? '-')
    ],
    [
      createField('Refunds', addGrayTextStyle),
      createField(totals?.refunds ?? '-')
    ],
    [
      createField((<div style={addGrayTextStyle}><span>Tips</span><br /><span style={{fontSize: '10px', fontStyle: 'italic'}}>Mobile purchases not included</span></div>)),
      createField(totals?.tips ?? '-', {alignSelf: 'baseLine'})
    ],
    [
      createField(),
    ],
    [
      createField('Tenders'),
    ]
  ]
  
  const sectionFourDefaults = [
    [
      createField('Cash', addGrayTextStyle),
      createField(totals?.cash ?? '-'),
    ],
    [
      createField('Card', addGrayTextStyle),
      createField(totals?.creditCard ?? '-')
    ],
    [
      createField('Mobile Wallet', addGrayTextStyle),
      createField(totals?.virtualCurrency ?? '-')
    ]
  ]
  
  const sectionFourRows = (() => {
    if (!totals || isEqual(Object.keys(totals), orderSummaryKeys)) {
      return sectionFourDefaults;
  } for (const key in totals) {
    if (orderSummaryKeys.includes(key)) {
      continue;
    }
    let rowEl = [
      createField(startCase(key), addGrayTextStyle),
      createField(totals[key] ?? '-')
    ];
    sectionFourDefaults.push(rowEl)
  }
  return sectionFourDefaults
})()
const sections = [sectionOneRows, sectionTwoRows, sectionThreeRows, sectionFourRows]
  
  const renderFieldRow = (fields, index) => (
    <div
      className={styles.row}
      key={`${fields?.columnOne?.value}-${index}`}
    >
      {map(fields, (field) => (
        <div className={styles.column} style={field?.style}>
          {field?.value}
        </div>
      ))}
    </div>
  )

  const content = map(sections, (section) => {
    return (
      <>
        <div className={styles.borderRow} />
        {map(section, renderFieldRow)}
      </>
    )
  })
  
  return (
    <SidebarModal onClose={onClose} title={"Summary"} show={true} className={classNames}>
        {content}
    </SidebarModal>
  )
}

export default AttendantSummary
